import { useQuery } from '@tanstack/react-query';

import { listPointsPurchaseOffers } from '~/services/LuxLoyalty';

import { pointsPurchaseQueryKeys } from './pointsPurchaseQueryKeys';

export function useGetPointsPurchaseOffersPreview(currency: string, enabled: boolean) {
  return useQuery({
    queryKey: pointsPurchaseQueryKeys.offersPreview(currency),
    queryFn: async ({ signal }) => listPointsPurchaseOffers(currency, { signal }),
    enabled,
  });
}
